module.exports = __WEBPACK_EXTERNAL_MODULE__aws_amplify_cache__;